import {
	BaechaType,
	BaechaWorkDayStatusEnum,
	BaljuStatusType,
	CallPassType,
	CarType,
	MhType,
	PriceReceiveMethodEnum,
	PriceType, ScheduleType
} from "../../types/Type";
import {getIsDev, getIsLocal} from "../../util/host";

export interface BaechaList2TableItem {
	id: string;
	baechaNo: number;
	status: BaljuStatusType;
	baechaType: BaechaType;
	createDate: Date;
	workArriveDate: Date;
	isWorkMonth: boolean;

	baljuGroupId: string;
	baljuingGroupId: string;
	baljuGroupName: string;
	sujuGroupName?: string;

	baljuUserId: string;
	baljuMemberId: string;
	baljuUserName: string;
	baljuUserNickname: string;
	baljuUserPhoneNum: string;

	sujuUserId?: string;
	sujuMemberId?: string;
	sujuUserName?: string;
	sujuUserPhoneNum?: string;
	sujuUserNickname?: string;
	// isOnlyCall: boolean; // callPassItemList로 판별
	// sujuUserPoint?: number; // 알 수 있나?

	region?: string;
	workLoc?: string;
	baechaLatitude?: number;
	baechaLongitude?: number;
	sujuMemberSettingLocation?: string;
	sujuMemberSettingLatitude?: number;
	sujuMemberSettingLongitude?: number;
	sujuMemberSettingDistance?: number;

	carType: CarType;
	workDay?: number;
	workHour?: number;

	price: number;
	fee: number;

	priceType: PriceType;
	priceReceiveMethod: PriceReceiveMethodEnum;

	baljuPoint?: number;
	sujuPoint?: number;

	workContent?: string; // 작업내용
	workEtc?: string; // 특이사항

	isHaveEvent?: boolean;

	// 어뷰징 관련
	previousBaechaNoList: {
		baechaNo: number;
		createDate: Date;
		workArriveDate: Date;
	}[];
	sujuMemberCarList: {
		carType: CarType;
		isActive: boolean;
	}[];
	// isScheduleExtended?: boolean; // baechaWorkDayList 판별

	// 클릭하면 펼쳐지는 정보
	privateAddress?: string;
	privateNote?: string;
	privatePhoneNum?: string;
	baechaWorkDayList: BaechaWorkDayItem[];
	baechaUpdateHistoryList: BaechaUpdateHistoryItem[];
	callPassItemList: CallPassItem[];
}

export interface BaechaWorkDayItem {
	id: string;
	workDate: Date;
	mhType: MhType;
	price: number;
	priceType: PriceType;
	overtimePrice?: number;
	doneDate?: Date;
	doneMemberId?: string;
	status?: BaechaWorkDayStatusEnum;
	reason?: string;
}

export interface BaechaUpdateHistoryItem {
	id: string;
	createDate: Date;
	message: string;
}

export interface CallPassItem {
	id: string;
	createDate: Date;
	callPassType: CallPassType;
	memberId: string;
	userId: string;
	carTypeRank: number;
	memberRank: number;
	carType: CarType;
	carNumber: string;
	memberNickname: string;
	isBenefit?: boolean;
	duplicateSujuCount?: number;
	schedule?: ScheduleType;
	callRegionLatitude?: number;
	callRegionLongitude?: number;
	distance?: number; // baecha.lat_lng <-> call_pass.lat_lng 간 거리
	point?: number;
	userName?: string;
	userPhoneNum?: string;
	memberSettingDistance?: number;
	memberSettingLatitude?: number;
	memberSettingLongitude?: number;
	memberSettingLocation?: string;
}

export interface GetBaechaListParams {
	baechaNo?: number | number[];
	baechaStatus?: string[];
	baechaRegion?: string;
	baechaCreateDate?: string;
	baechaWorkArriveDate?: string;
	baechaWorkDayStatus?: BaechaWorkDayStatusEnum;

	groupName?: string;
	name?: string;
	nickname?: string;
	phoneNum?: string;
	scope?: 'balju' | 'suju' | 'all';

	isMultipleMatchedWithin90?: boolean;
	isFirstBaljuPointNotReceived?: boolean;

	offset?: number;
	limit?: number;
}

export const emptyGetBaechaListParams: GetBaechaListParams = {
	baechaNo: undefined,
	baechaStatus: undefined,
	baechaRegion: undefined,
	baechaCreateDate: undefined,
	baechaWorkArriveDate: undefined,

	groupName: '모두의배차장',
	name: undefined,
	nickname: undefined,
	phoneNum: undefined,
	scope: 'all',

	offset: undefined,
	limit: 10,
}

export type BaechaWorkDayModalType = 'ADD' | 'EDIT' | 'DELETE' | 'DONE' | undefined;

export interface ModalDataIF {
	type: BaechaWorkDayModalType;
	data?: BaechaList2TableItem;
	selectedBaechaWorkDayData?: BaechaWorkDayItem;
}

export const emptyModalData: ModalDataIF = {
	type: undefined,
	data: undefined,
	selectedBaechaWorkDayData: undefined,
}